import { fetchApi } from '@/config/axiosSetting';
import { FilesStaticsResponseQueryType } from '@/modules/Dashboard/queries/fileStaticChart/filesStaticsQuery.type';
export const fileStatisticsModalQueryFunction =
  (): Promise<FilesStaticsResponseQueryType> => {
    return fetchApi.get('homepage/files_statistics/detail/', {
      params: { source: 'pwa' },
    });
  };
